import type {PaymentPlan} from './types';

import {Currency} from '../../../money';

export const DefaultPaymentPlan: PaymentPlan = {
  // @ts-expect-error: TODO: describy why
  currency: Currency.USD.id.toUpperCase(),
  description: '',
  processing: 'internal',
  schedule: [],
  total: 0,
};

export const MAX_PRICE = 1000000; // $10000

export const MIN_PRICE = 100; // $1
